import React from 'react';
import { getSeasonStatsUrl } from '../../data/utils';

export default function Standings(props) {
    const url = getSeasonStatsUrl(props.seasonId, props.sportId);

    return (
        <iframe title="xs-stats-iframe" src={url} className="c_34" />
    );
}
